import { Flex, Stack, Text } from "@huub-web/ui";
import { padNumber } from "@huub-web/utils";
import {
  containerStyle,
  illustrationContainerStyle,
  indexTextStyle,
} from "./AnalysisIndicator.css";

import { Illustration, type IllustrationProps } from "../Illustration";

export type AnalysisIndicatorProps = {
  index: number;
  illustration: IllustrationProps["name"];
};

export const AnalysisIndicator = ({
  index,
  illustration,
}: AnalysisIndicatorProps) => (
  <Stack className={containerStyle}>
    <Flex
      align="flex-end"
      justify="center"
      className={illustrationContainerStyle}
      grow
    >
      <Illustration name={illustration} size="xs" />
    </Flex>
    <Text align="center" color="navigation" bold className={indexTextStyle}>
      {padNumber(index)}
    </Text>
  </Stack>
);
